import { render, staticRenderFns } from "./Playlists.vue?vue&type=template&id=4ba7f252"
import script from "./Playlists.vue?vue&type=script&lang=js"
export * from "./Playlists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pforret/Code/Movix/laravel/showtimes.movix/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ba7f252')) {
      api.createRecord('4ba7f252', component.options)
    } else {
      api.reload('4ba7f252', component.options)
    }
    module.hot.accept("./Playlists.vue?vue&type=template&id=4ba7f252", function () {
      api.rerender('4ba7f252', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Playlists.vue"
export default component.exports